<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import {
  productsMethods,
  warehouseMethods,
  benchmarksMethods,
  productsReportMethods,
} from '@state/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'Benchmark',
  page: {
    title: 'Benchmark',
    meta: [
      {
        name: 'Benchmark',
        content: 'Benchmark',
      },
    ],
  },
  components: { Layout, PageHeader, BaseDatatable },
  data() {
    return {
      title: 'Configuración de Máximos',
      items: [
        {
          text: 'Reportes',
        },
        {
          text: 'Configuración de reportes',
        },
        {
          text: 'Máximos',
          active: true,
        },
      ],
      tableHeadersWarehouse: [
        { key: 'info', label: 'Info' },
        { key: 'description', label: 'Bodega' },
        // { key: 'benchmark', label: '', class: 'w-15' },
        { key: 'actions', label: '', class: 'w-25' },
      ],
      tableHeadersUbications: [
        { key: 'nit', label: 'NIT', class: 'd-none d-lg-table-cell' },
        { key: 'name', label: 'Ubicación' },
        // { key: 'benchmark', label: '', class: 'w-15' },
        { key: 'actions', label: '', class: 'w-25' },
      ],
      filter: [],
      request_data: [],
      inputBenchmark: [],
      modalSendBenchmark: false,
      sendingData: [],
      sendingBenchmarks: false,
    }
  },
  computed: {
    ...mapGetters({
      selected_for_report: 'retina/products/selected_for_report',
    }),
  },
  methods: {
    ...benchmarksMethods,
    ...productsMethods,
    ...productsReportMethods,
    ...warehouseMethods,
    myProviderWarehouse(ctx) {
      let context = this
      const promise = context.fetchWarehouses(
        this.$table_params(ctx) +
          '&paginate=true&product=' +
          this.selected_for_report.id_ext
      )
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          return []
        })
    },

    updateRequestData(warehouse, ubication, reference) {
      let search = this.request_data.find((d) => {
        return (
          d.id_warehouse == warehouse.id &&
          d.id_location == (ubication ? ubication.id : null)
        )
      })
      if (Boolean(search)) {
        search['benchmark'] = this.$refs[reference].vModelValue
      } else {
        let id, name, multi_ubication, ubications, w
        ;({ id, name, multi_ubication, ubications, ...w } = warehouse)
        w['id_warehouse'] = id
        // w['warehouse_name'] = name
        w['multi_location'] = ubications.length > 0 ? true : false

        let u
        if (Boolean(ubication)) {
          ;({ id, name, ...u } = ubication)
          u['id_location'] = id
          u['location_name'] = name
        } else {
          u = {}
          u['id_location'] = null
          u['nit'] = null
          u['location_name'] = null
        }

        let b = {}
        Object.assign(b, w, u, this.selected_for_report, {
          benchmark: this.$refs[reference].vModelValue,
        })
        this.$refs[reference].value = this.$refs[reference].vModelValue
        this.request_data.push(b)
      }
    },
    async createP() {
      await this.createProduct(this.selected_for_report).then((data) => {
        this.modalSendBenchmark = false
      })
    },
    async createB() {
      if (this.request_data.length === 0){
        this.$generate_toast(this, 'warn', 'Sin datos para guardar, verifique!')
        return false
      }
      this.request_data.map(async (site) => {
        this.sendingBenchmarks = true
        const response = await this.createBenchmark(site).then((data) => {
          this.$generate_toast(this, 'success', 'Máximo de producto creado/actualizado')
          this.sendingData.push(data)
          this.$refs.tableWarehouse.refresh()
        })
        return response
      })
    },
    async setBenchmarks() {
      this.sendingData = []
      this.modalSendBenchmark = true
      await this.createP()
      await this.createB()
      this.request_data = []
      this.sendingBenchmarks = false      
    },
    setValues(warehouse) {
      warehouse.ubications.map((ubication) => {
        this.$refs[ubication.id].vModelValue = this.$refs[
          warehouse.id
        ].vModelValue
        this.$refs[ubication.id].value = this.$refs[warehouse.id].vModelValue
        this.updateRequestData(warehouse, ubication, ubication.id)
      })
    },
    back() {
      this.$router.push('/reports/config')
    },
    valueBenchmark(warehouse, ubication, reference) {
      let search = this.request_data.find((d) => {
        return (
          d.id_warehouse == warehouse.id &&
          d.id_location == (ubication ? ubication.id : null)
        )
      })
      if(search)return search.benchmark
      else return ubication ? ubication.benchmark : warehouse.benchmark
    },
    clearFilter(id) {
      this.filter = []
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card class="col-lg-4 p-0">
      <b-card-title class="lead mb-3">
        <strong>
          {{ selected_for_report.name }}
        </strong>
      </b-card-title>

      <b-card-sub-title class="mb-2 lead">
        <p class="text-dark">
          Referencia: {{ selected_for_report.reference }}
        </p>
        <p v-if="selected_for_report.id_ext1" class="text-dark">
          Extensión: {{ selected_for_report.id_ext1 }}
          {{ selected_for_report.ext_description }}
        </p>
        <p v-else>
          Sin extensión
        </p>
      </b-card-sub-title>

      <b-button @click="back()" variant="link" class="text-blue">
        <i class="fas fa-arrow-left"></i> Volver
      </b-button>
    </b-card>
    <div class="bg-white p-3 m-0">
      <h5 class="mt-3">Bodegas</h5>
      <BaseDatatable
        ref="tableWarehouse"
        :drfprovider="myProviderWarehouse"
        :tableheaders="tableHeadersWarehouse"
      >
        <template v-slot:cell(info)="row">
          <span class="text-blue">{{ row.item.code }}</span>
        </template>
        <template v-slot:cell(description)="row">
          {{ row.item.description }}
        </template>

        <template #cell(actions)="row">
          <b-button
            v-if="row.item.ubications.length > 0"
            size="sm"
            variant="link"
            class="text-info"
            @click="row.toggleDetails"
          >
            <span v-if="row.detailsShowing"
              ><i class="fas fa-search-minus fa-lg"></i>
              <span class="d-none d-md-inline"> Ver menos</span></span
            >
            <span v-else
              ><i class="fas fa-search-plus fa-lg"></i>
              <span class="d-none d-md-inline">
                Ver {{ row.item.ubications.length }} más</span
              >
              <span class="d-sm-inline d-md-none">
                {{ row.item.ubications.length }}</span
              >
            </span>
          </b-button>
          
            <!-- :value="row.item.benchmark" -->
          <b-form-input
            v-else
            :ref="row.item.id"
            :value="valueBenchmark(row.item, null, row.item.id)"
            size="sm"
            type="number"
            placeholder="Establecer Máximo"
            @input="updateRequestData(row.item, null, row.item.id)"
          ></b-form-input>
        </template>

        <template #row-details="row">
          <div class="bg-white p-2 m-0">
            <b-row>
              <b-col md="5" class="mt-0 mb-1">
                <b-input-group size="sm">
                  <b-form-input
                    :ref="row.item.id"
                    type="number"
                    min="0.00"
                    placeholder="Establecer Máximo"
                    @input="setValues(row.item)"
                  >
                  </b-form-input>
                  <b-input-group-append>
                    <div class="ml-2 mt-1 text-primary">
                      <i class="fas fa-arrow-alt-circle-right fa-lg"></i>
                      <small> Aplicar a todo</small>
                    </div>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col md="7" xs="12" class="mt-0 mb-1">
                <b-form-group
                  label="Buscar"
                  label-for="filter-input"
                  label-cols-md="3"
                  label-align-md="right"
                  label-size="md"
                  label-class="d-none d-md-block"
                  :content-cols-md="9"
                  :content-cols-xl="9"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      id="filter-input"
                      :ref="row.index"
                      v-model="filter[row.index]"
                      type="search"
                      placeholder="Ingrese búsqueda"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        :disabled="!filter[row.index]"
                        @click="clearFilter(row.index)"
                      >
                      Limpiar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-table
              class="bg-white mb-0"
              :items="row.item.ubications"
              :filter="filter[row.index]"
              :fields="tableHeadersUbications"
              no-provider-filtering
            >
              <template #cell(nit)="row">
                <p class="pt-1 m-0">{{ row.item.nit }}</p>
              </template>
              <template #cell(name)="row">
                <small class="d-sm-inline d-md-none">
                  {{ row.item.nit }} <br />
                </small>
                {{ row.item.name }}
              </template>
              <template #cell(actions)="data">
                  <!-- :value="data.item.benchmark" -->
                <b-form-input
                  :ref="data.item.id"
                  :value="valueBenchmark(row.item, data.item, data.item.id)"
                  size="sm"
                  type="number"
                  placeholder="Establecer Máximo"
                  @input="updateRequestData(row.item, data.item, data.item.id)"
                ></b-form-input>
              </template>
            </b-table>
          </div>
        </template>
      </BaseDatatable>
      <div class="row mt-2">
        <div class="col text-right">
          <b-button variant="primary" @click="setBenchmarks()">
            Guardar
          </b-button>
        </div>
      </div>
    </div>
    <b-modal
      ok-only
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      size="xl"
      :busy="sendingBenchmarks"
      v-model="modalSendBenchmark"
      @hidden="request_data = []"
    >
      <p>Enviando</p>
      <ul>
        <li
          v-for="(bench, index) in sendingData"
          :key="index"
          class="text-success"
        >
          {{ bench.site.warehouse.description }} -
          {{ bench.site.location ? bench.site.location.name : '' }}
          <i class="fas fa-check-circle"></i>
        </li>
      </ul>
    </b-modal>
  </Layout>
</template>
